import type { $Fetch } from 'ofetch';
import type { CommissionRule, CommissionRuleCommand } from '@/domain/model/Commission';
import type { Page } from '@/domain/model/Page';
import type { CommissionRuleGateway } from '@/application/port/out/CommissionRuleGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/commission-rules';

export class HttpCommissionRuleGateway implements CommissionRuleGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { ativo?: boolean; page?: number; size?: number }): Promise<Page<CommissionRule>> {
    const params: Record<string, string | number | boolean> = {};
    if (typeof p.ativo === 'boolean') params['ativo'] = p.ativo;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<CommissionRule>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<CommissionRule> {
    const res = await this.client<ApiResponse<CommissionRule>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async criar(command: CommissionRuleCommand): Promise<CommissionRule> {
    const res = await this.client<ApiResponse<CommissionRule>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async atualizar(id: string, command: CommissionRuleCommand): Promise<CommissionRule> {
    const res = await this.client<ApiResponse<CommissionRule>>(
      `${PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async desativar(id: string): Promise<void> {
    await this.client<null>(`${PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
